export default function () {

    this.load('splash');
};
